import Immutable from 'immutable';
import { createSelector } from 'reselect';

import { selectAppConfig } from 'app/selectors/AppSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';

const selectBibEntity = createSelector([selectBibEntities, (_state, bibId) => bibId], (bibs, bibId) => {
  const bib = bibs.get(bibId, null);
  if (!bib) {
    return null;
  }

  return Immutable.Map({
    bib_audience: bib.getIn(['briefInfo', 'audiences', 0], ''),
    bib_availability_status: bib.getIn(['availability', 'localisedStatus'], ''),
    bib_fiction_type: bib.getIn(['briefInfo', 'contentType'], ''),
    bib_format: bib.getIn(['briefInfo', 'format'], ''),
    bib_fulfillment_provider: bib.getIn(['policy', 'provider'], ''),
    bib_group_key: null, // TODO: get from state once we have this in our API response(s)
    bib_hold_count: bib.getIn(['availability', 'heldCopies'], 0),
    bib_metadata_id: bib.get('id', ''),
    bib_total_item_count: bib.getIn(['availability', 'totalCopies'], 0)
  });
});

const selectOrganizationEntity = createSelector([selectAppConfig], appConfig => {
  const subdomain = appConfig?.get('libraryDomain') ?? '';
  return Immutable.Map({ subdomain });
});

const selectProductEntity = createSelector([selectAppConfig], appConfig => {
  const isMobile = appConfig?.get('mobileApp', false) ?? false;
  const currentURL = appConfig?.get('currentURL');

  let product = 'core';
  if (currentURL?.includes('/v2/events')) product = 'events';
  else if (currentURL?.includes('/v2/locations')) product = 'web';

  return isMobile
    ? Immutable.Map({
        product_id: `apps_${appConfig?.get('mobileAppPlatform') ?? ''}`.toLowerCase(),
        product_version: appConfig?.get('mobileAppVersion') ?? ''
      })
    : Immutable.Map({
        product_id: product,
        product_version: appConfig?.get('coreVersion') ?? ''
      });
});

const selectUserEntity = createSelector([selectCurrentUser], currentUser => {
  if (!currentUser) {
    return null;
  }

  const analyticsId = currentUser.get('encodedId') ?? '';
  const isStaff = currentUser.get('staff', false);

  return Immutable.Map({
    user_analytics_id: analyticsId,
    user_type: isStaff ? 'staff' : 'patron'
  });
});

export { selectBibEntity, selectOrganizationEntity, selectProductEntity, selectUserEntity };
